import React, { Component } from 'react'
import { connect, compose, withBeacon } from '@hocs'
import { likeComment, selectComment } from '@app-core/place/actions'
import PlaceCommentRow from './components/PlaceCommentRow'
import { openPost } from '@libs/appUrl'
import { trackingShareProperty } from '@app-core/beacon/beacon'

class PlaceCommentRowContainer extends Component {
  onClickHeart = () => {
    const { comment, place } = this.props
    this.props.likeComment({
      comment: comment.toJS(),
      like: comment.get('currentUserLike') ? 0 : 1,
      place: place.toJS(),
    })
  }

  onClickRow = () => {
    const { comment } = this.props
    this.props.selectComment({ comment })
  }

  onClickedUser = (e) => {
    e && e.stopPropagation()
    const { place, comment, amplitudeEventTrack } = this.props
    const { userInfo } = comment.toJS()
    amplitudeEventTrack('click.review.user', trackingShareProperty(place))
    openPost(`/user/${userInfo.mid}`)
  }

  render() {
    const comment = this.props.comment.toJS()
    const place = this.props.place.toJS()
    return (
      <PlaceCommentRow
        comment={comment}
        place={place}
        onClickedUser={this.onClickedUser}
        onClickHeart={this.onClickHeart}
        onClickRow={this.onClickRow}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const placeId = state.place.get('placeId')
  return {
    comment: state.place.getIn(['comments', ownProps.commentId]),
    place: state.place.getIn(['places', placeId]),
  }
}

export default compose(
  withBeacon,
  connect(mapStateToProps, {
    likeComment,
    selectComment,
  }),
)(PlaceCommentRowContainer)
